/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DeviceLocationPermission {
    AllTheTime = 'all_the_time',
    WhileUsingApp = 'while_using_app',
    Denied = 'denied',
    AllTheTimeCoarse = 'all_the_time_coarse',
    WhileUsingAppCoarse = 'while_using_app_coarse'
}


export function instanceOfDeviceLocationPermission(value: any): boolean {
    for (const key in DeviceLocationPermission) {
        if (Object.prototype.hasOwnProperty.call(DeviceLocationPermission, key)) {
            if (DeviceLocationPermission[key as keyof typeof DeviceLocationPermission] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DeviceLocationPermissionFromJSON(json: any): DeviceLocationPermission {
    return DeviceLocationPermissionFromJSONTyped(json, false);
}

export function DeviceLocationPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceLocationPermission {
    return json as DeviceLocationPermission;
}

export function DeviceLocationPermissionToJSON(value?: DeviceLocationPermission | null): any {
    return value as any;
}

export function DeviceLocationPermissionToJSONTyped(value: any, ignoreDiscriminator: boolean): DeviceLocationPermission {
    return value as DeviceLocationPermission;
}

